module.exports = __webpack_public_path__ + "img/qxc.b73f703a.jpg";